import { render } from "./StoryCardShimmer.vue?vue&type=template&id=78b452d9"
const script = {}
script.render = render

export default script